import React from 'react';
import './VerifiedBadge.css';

function VerifiedBadge({ size = 'small' }) {
  return (
    <span className={`verified-badge-peacock ${size}`} title="Verified ONTAP Member">
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
      </svg>
    </span>
  );
}

export default VerifiedBadge;
